import type { Observer } from '@naturehouse/nh-essentials/lib/architecture/ObserverPattern';
import instantiateSimpleCarousel from '@naturehouse/design-system/components/molecules/carousel/simple-carousel/simple-carousel';
import ApiRequestState from './store/ApiRequestState';

export class InstantiateSwiperInstances implements Observer {
    public constructor(apiRequestState: ApiRequestState) {
        apiRequestState.attach(this);
    }

    public update(subject: ApiRequestState): void {
        if (subject.state === ApiRequestState.REQUEST_SUCCESS) {
            instantiateSimpleCarousel();
        }
    }
}

export default new InstantiateSwiperInstances(ApiRequestState.getInstance());
